import {
  classNames,
  FlexColumn,
  ItemContent,
  Skeleton,
  SkeletonBlock,
  TableCell,
  TableRow,
  tableRowSizeVariants,
  useTable,
} from "@opensea/ui-kit"
import { Item } from "../Item"
import { RECEIPT_TABLE_COLUMN_CLASSNAMES } from "./constants"

export const ReceiptRowDisplaySkeleton = () => {
  const { size } = useTable()
  const { image } = tableRowSizeVariants({ size })

  return (
    <TableRow>
      <TableCell className={RECEIPT_TABLE_COLUMN_CLASSNAMES.item}>
        <Item variant="unstyled">
          <SkeletonBlock className={classNames(image(), "w-fit")} />
          <ItemContent>
            <Skeleton className="w-24" />
            <Skeleton className="w-20" />
          </ItemContent>
        </Item>
      </TableCell>
      <TableCell className={RECEIPT_TABLE_COLUMN_CLASSNAMES.price}>
        <FlexColumn className="items-end">
          <Skeleton className="w-12" />
          <Skeleton className="w-16" />
        </FlexColumn>
      </TableCell>
    </TableRow>
  )
}
